import { useMutation } from '@apollo/client'
import { CustomerRequestTestSession, CustomerRequestTestSessionVariables } from '../../types'
import { CUSTOMER_REQUEST_TEST_SESSION } from './operations'

export const useCustomerRequestTestSession = () =>
  useMutation<CustomerRequestTestSession, CustomerRequestTestSessionVariables>(
    CUSTOMER_REQUEST_TEST_SESSION
  )
